<template>
  <div class="container">
    <mt-header fixed :title="title" class="head">
      <!--<router-link to="/imgupdate" slot="left">-->
        <!--<mt-button class="c_size_10" icon="back"></mt-button>-->
      <!--</router-link>-->
      <!--<mt-button slot="right" class v-show="auth.editable" @click="commit">提交</mt-button>-->
    </mt-header>

    <div class="c_red c_p_10">以下信息是质保单中的关键信息，请准确填写</div>
    <div class="form" :class="auth.editable?'':'c_no_pointer'">
      <div class="item-group c_m_b_10 bg_white"  v-for="(item,i) in formEditList" :key="i">
        <div class="item-title c_nowrap">
          <span v-show="item.require=='Y'" class="c_red">*</span>{{item.displayname}}
        </div>
        <div class="item-content">
          <span class="item-value">
            <input type="text" v-if="item.autosave" @change="autoSave(item.attribute,item.value)" :placeholder="auth.editable?item.memo:'暂无数据'" v-model="item.value"/>
            <input type="text" v-else :placeholder="auth.editable?item.memo:'暂无数据'" v-model="item.value"/>
          </span>
        </div>
      </div>
    </div>

    <div class="bg_gray c_white c_p_10 c_size_10">服务信息</div>
    <template v-for="(item,i) in formList">
      <div class="form c_no_pointer" :key="i">
        <template v-if="item.type=='text'||item.type=='int'||item.type=='double'||item.type=='switch'||item.type=='rate'">
          <div class="procedure" v-if="item.setting && item.setting.group">
            <div class="procedure-title">{{item.setting.group}}</div>
          </div>
          <div class="item-group c_m_b_10 bg_white" v-show="!item.setting.isHide">
            <div class="item-title c_nowrap">
              <!--<span class="c_red">*</span>-->
              {{item.displayname}}
            </div>
            <div class="item-content" :class="auth.editable?'':'c_no_pointer'">
              <template v-if="item.type=='int'||item.type=='double'">
                <span class="item-value">
                  <input
                    type="number"
                    @change="autoSave(item.attribute,item.value)"
                    :placeholder="item.memo"
                    v-model="item.value"
                  />
                </span>
              </template>
              <template v-else-if="item.type=='switch'">
                <span class="item-value">
                  <mt-switch v-model="item.value" @change="autoSave(item.attribute,item.value)"></mt-switch>
                </span>
              </template>
              <template v-else-if="item.type=='rate'">
                <span class="item-value star">
                  <i
                    class="iconfont icon-star"
                    :class="(si+1)<=item.value?'c_blue':'c_gray'"
                    v-for="(sn,si) in 5"
                    :key="si"
                    @click="rateClick(item,i,si+1)"
                  ></i>
                </span>
              </template>
              <template v-else-if="item.type=='text'">
                <span class="item-value">
                  <input
                    type="text"
                    @change="autoSave(item.attribute,item.value)"
                    :placeholder="item.memo"
                    v-model="item.value"
                  />
                </span>
              </template>
            </div>
          </div>
        </template>
      </div>
      <div class="procedure c_no_pointer">
        <template v-if="item.type=='img'||item.type=='checkbox'||item.type=='radio'||item.type=='textarea'||item.type=='formula'">
          <div class="procedure-group">
            <div class="procedure-title">
              {{item.displayname}}
              <template v-if="item.type=='img'">({{item.value.length||0}}/{{item.imgmax}})</template>
              <template v-else-if="item.type=='formula'">{{item.value||''}}</template>
            </div>
            <div class="procedure-content">
              <template v-if="item.type=='img'">
                <div>
                  <div class="c_rela procedure-img" v-for="(n,index) in item.value" :key="index" v-if="index<item.imgmax">
                    <div class="imgdel" v-show="auth.editable" @click="delClick(item,i,index)">×</div>
                    <img :src="qiniu+n+'?imageView2/1/w/100/h/100'" :data-src="qiniu+n" @click="imgShowClick" class/>
                  </div>
                  <div class="" v-show="item.value.length<1">暂无数据</div>
                  <update-file
                    :type="item.setting?item.setting.cameraMode:'all'"
                    v-show="((item.value.length||0)<item.imgmax) && auth.editable"
                    @fileChange="getUrl($event,item,i)"
                  ></update-file>
                </div>
                <div class="c_p_20 c_p_t_0 c_p_b_0" :class="item.memo?'':'c_hide'">
                  <template v-for="(memoItem,memoIndex) in item.memo">
                    <view :key="memoIndex">{{memoIndex+1}}:{{memoItem}}</view>
                  </template>
                </div>
              </template>
              <template v-else-if="item.type=='textarea'">
                <template v-if="auth.editable">
                  <textarea v-model="item.value" :placeholder="item.memo" cols="30" rows="10" @change="autoSave(item.attribute,item.value)"></textarea>
                </template>
                <template>
                  {{item.value||"暂无数据"}}
                </template>
              </template>
              <template v-else-if="item.type=='checkbox'">
                <div class="c_flex c_item_center c_flex_wrap module-body">
                  <!--<div  :class="auth.editable?'':'c_no_pointer'" class="checkbox module-body-subItem c_rela" v-for="(subItem,subIndex) in item.setting" :key="subIndex">-->
                  <div class="module-body-subView c_nowrap c_flex c_flex_center c_rela" :class="subItem.checked?'on  ':'bg_white'" v-for="(subItem,subIndex) in item.setting.dataList" :key="subIndex">
                    <input type="checkbox" class="module-body-subInput" :name="item.attribute" @change="inputChange(item,i,subIndex)"/>
                    {{subItem.name}}
                  </div>
                  <!--</div>-->
                </div>
              </template>
              <template v-else-if="item.type=='radio'">
                <div class="c_flex c_item_center c_flex_wrap module-body">
                  <!--<div  :class="auth.editable?'':'c_no_pointer'" class="checkbox module-body-subItem c_rela" v-for="(subItem,subIndex) in item.setting" :key="subIndex">-->
                    <div v-for="(subItem,subIndex) in item.setting.dataList" :key="subIndex" class="module-body-subView c_nowrap c_flex c_flex_center c_rela" :class="subItem.checked?'on  ':'bg_white'">
                      <input type="radio" class="module-body-subInput" :name="item.attribute"  @change="inputChange(item,i,subIndex)" />
                      {{subItem.name}}
                    </div>
                  <!--</div>-->
                </div>
              </template>
              <template v-else-if="item.type=='formula'">
                <div class=" module-body form bg_white c_w c_hidden">
                  <div class="item-group c_m_b_10 bg_white" v-for="(subItem,subIndex) in item.setting.dataList" :key="subIndex">
                    <div class="item-title c_nowrap">
                      {{subItem.name}}
                    </div>
                    <div class="item-content">
                  <span class="item-value">
                    <input type="text" class="bg_white" disabled  v-model="subItem.value"/>
                  </span>
                    </div>
                  </div>
                  <div class="c_red c_p_t_10" v-show="item.setting&&item.setting.tips">
                    {{'提示：'+item.setting.tips}}
                  </div>
                  <div class="c_memo c_p_t_10 c_size_30" v-show="item.memo">
                    {{'备注：'+item.memo}}
                  </div>
                </div>
              </template>
            </div>
            <div class="procedure-memo" v-show="(item.type!='textarea')&&(item.type!='formula')&&item.memo">
              <div>备注：{{item.memo}}</div>
            </div>
          </div>
        </template>
        <template v-else-if="item.type=='signature'">
          <div class="item-group c_m_b_10 bg_white">
            <mt-cell :title="item.displayname">
              <mt-button
                size="small"
                plain
                style="width:100%;"
                :disabled="!auth.editable"
                @click="signatureVisible=true"
              >{{signatureImg && item.value?'点击签字':'编辑签字'}}</mt-button>
            </mt-cell>
            <mt-popup class="signaturePopup" v-model="signatureVisible" position="right">
              <signature
                v-show="signatureVisible"
                :signatureVis="signatureVisible"
                :canvasWidth="canvasWidth"
                @signatureObj="signatureObj"
              />
            </mt-popup>

            <div class="signature-img-wrapper">
              <img
                v-show="signatureImg||item.value"
                @change="$forceUpdate()"
                :src="!signatureImg?qiniu+item.value+'?imageView2/1/w/100/h/100':signatureImg+'?imageView2/1/w/100/h/100'"
                alt
              />
            </div>
          </div>
        </template>

      </div>
    </template>

    <!--<div class="activation-seat"></div>-->
    <!--<div class="activation-modal c_shadow c_flex c_flex_col">-->
      <!--<div class="activation-content form c_flex_1">-->
          <!--<div class="item-group c_m_b_10 bg_white"  v-for="(item,i) in formEditList" :key="i">-->
            <!--<div class="item-title c_nowrap">-->
              <!--<span v-show="item.require=='Y'" class="c_red">*</span>{{item.displayname}}-->
            <!--</div>-->
            <!--<div class="item-content">-->
              <!--<span class="item-value">-->
                  <!--<input type="text" v-if="item.autosave" @change="autoSave(item.attribute,item.value)" :placeholder="item.memo" v-model="item.value"/>-->
                  <!--<input type="text" v-else :placeholder="item.memo" v-model="item.value"/>-->
                <!--</span>-->
            <!--</div>-->
          <!--</div>-->
      <!--</div>-->
      <!--<div class="activation-foot">-->
        <!--<div class="c_btn">确认并激活质保</div>-->
      <!--</div>-->
    <!--</div>-->
    <div class="c_btn_seat" :class="auth.editable?'':'c_hide'"></div>
    <div class="c_btn fix" :class="auth.editable?'':'c_hide'" @click="activationClick">确认并激活质保</div>

    <div class="tip-modal c_flex c_flex_center" v-show="tipModal">
      <div class="tip-modal-bg"></div>
      <div class="tip-modal-content c_flex c_flex_center" @click="toLogin">
        <div>
          <div class="c_center">竣工单激活成功</div>
          <div class="c_center">请登录后查看详情</div>
          <div class="c_blue c_m_t_10 c_center">点击登录</div>
        </div>
      </div>
    </div>

    <!--图片显示-->
    <c-imgshow @part_close="part_close" :ispart_imgshow="ispart_imgshow" :imgshow_url="imgshow_url"></c-imgshow>

    <!-- <signature /> -->
  </div>
</template>

<script>
import axios from "axios";
import { Indicator, MessageBox } from "mint-ui";
import UpdateFile from "./update-file";
import CImgshow from "./c-imgshow";
import signature from "./signature";

export default {
  components: { UpdateFile, CImgshow, signature },
  data() {
    return {
      qiniu: this.$$api.mobile.qiniuDownload,
      // 是否需要定义value 的类型，arr，string，int
      // 表单字段排序
      // 怎么控制跳转到这个页面
      //----表单列表， 排序
      formList_temp: [],
      formList: [],
      formcode: "",
      sid: "",
      itemid: "",
      formid: "",
      title: "激活质保",
      haspass: false,
      ispass: false,
      // 图片显示
      ispart_imgshow: false,
      imgshow_url: "",
      // 权限控制
      auth: {
        // 是否开始自动保存
        isAutoSave: false,
        //是否有提交权限
        editable: false,
        //是否 -- 可以提交
        isCommit: true
      },

      //签字 图片路径
      signatureImg: false,
      //签字 组件显示隐藏
      signatureVisible: false,
      canvasWidth: document.body.clientWidth,

      formEditList:[
        {attribute: "customerName",displayname: "客户名称",type: "text",autosave:true,require:'Y',nullTip:'请填写客户名称',memo:'请填写客户名称',},
        {attribute: "idcard",displayname: "证件号",type: "text",autosave:true,require:'Y',nullTip:'请填写证件号',memo:'请填写证件号',},
        {attribute: "customerTel",displayname: "联系电话",type: "text",autosave:true,require:'Y',nullTip:'请填写联系电话',memo:'请填写联系电话',},
        {attribute: "email",displayname: "邮箱",type: "text",autosave:true,memo:'请填写邮箱',},
      ],
      tipModal:false,
    }
  },
  mounted() {
    this.$indicator.open();
    var sid = this.$route.query.sid;
    if(sid){
      this.getProcedureParam(sid);
    }else{
      var formcode = this.$route.query.formcode;
      if (formcode) {
        this.formcode = formcode;
      } else {
        // this.$router.go(-1);
      }
      var obj = JSON.parse(localStorage["obj"]);
      var procedure = obj.procedure;
      this.sid = procedure.billbid;
      this.itemid = procedure.itemid;
      this.formid = procedure.formid;
      this.title = procedure.itemname;
      this.load();
      this.getAuth();
    }
  },
  methods: {
    getProcedureParam(sid){
      let that = this;
      that.sid = sid;
      that.itemid = this.$route.query.itemid;
      that.formid = this.$route.query.formid;
      that.load();
      that.getAuth();
    },
    //获取页面内容
    load: function() {
      var $that = this;
      this.$ajax.get(this.$$api.mobile.getProcedureView,
        {
          formid: this.formid
        },
        function(res) {
          if (res.status == 200) {
            var arr = res.data.detailMsg.data.id_formb;
            $that.formList_temp = arr;
            $that.loadDetail();
          }
        }
      );
    },
    // 获取工序详情
    loadDetail: function() {
      var $that = this;
      this.$ajax.get(
        this.$$api.mobile.getProcedureDetail,
        {
          sid: this.sid,
          formid: this.formid
        },
        function(res) {
          if (res.status == 200) {
            var obj = res.data.detailMsg.data || {};
            var arr = $that.formList_temp;
            var arr_temp = arr.map(item => {
              let delArr = ["customerName","idcard","customerTel","email"];
              if(delArr.includes(item.attribute)){
                return {};
              }
              try {
                item.setting = JSON.parse(item.setting) || [];
                if(item.setting && item.setting.dataSourceType){
                  item.type = item.setting.dataSourceType;
                }
                if((item.setting instanceof Array)&& item.setting.length>0){
                  let ctt = JSON.stringify(item.setting);
                  item.setting = { dataList:JSON.parse(ctt) };
                }
              } catch (e) {
                item.setting = {};
              }
              if (item.memo && item.type == "img") {
                try {
                  item.memo = item.memo.split(";");
                } catch (e) {}
              }
              if (item.attribute == "ispass") {
                $that.haspass = true;
                item.setting.isHide = true;
              }
              if (item.type == "img") {
                item.value = [];
              } else if (item.type == "switch") {
                item.value = false;
              } else if (item.type == "rate") {
                item.value = 0;
              } else {
                item.value = "";
              }
              if (Object.keys(obj).length > 0) {
                for (let key in obj) {
                  if (item.attribute == key) {
                    if (item.type == "img") {
                      item.value = obj[key] ? obj[key].split(",") || [] : [];
                    } else if (item.type == "switch") {
                      item.value = obj[key] || false;
                    } else if (item.type == "rate") {
                      item.value = obj[key] || 0;
                    } else if (item.type == "date") {
                      if(obj[key]){
                        item.value = obj[key];
                      }
                    } else if (item.type == "scanQR") {
                      item.value = obj[key]?(obj[key].split(',')||[]):[];
                    }else if(item.type == 'multipleChoice'){
                      try {
                        item.value = JSON.parse(obj[key])||[];
                      }catch (e) {
                        item.value = [];
                      }
                    } else if (item.type == "radio") {
                      //修改setting
                      let value_temp;
                      // 兼容旧数据
                      try {
                        let old = JSON.parse(obj[key]);
                        for (let key in old) {
                          if (old[key]) {
                            value_temp = key;
                            break;
                          }
                        }
                      } catch (e) {
                        value_temp = obj[key];
                      }
                      let temp = item.setting.dataList.map(subitem => {
                        var bool;
                        if ((subitem.id||subitem.value) == value_temp) {
                          bool = true;
                        }
                        subitem.checked = !!bool;
                        return subitem;
                      });
                      item.setting.dataList = temp;
                      item.value = value_temp || "";
                    } else if (item.type == "checkbox") {
                      //修改setting
                      let value_temp = [];
                      // 兼容旧数据
                      try {
                        let old = JSON.parse(obj[key]);
                        for (let oldkey in old) {
                          if (old[oldkey]) {
                            value_temp.push(oldkey);
                          }
                        }
                        value_temp = value_temp.join(",");
                      } catch (e) {
                        value_temp = obj[key];
                      }
                      let arr = value_temp ? value_temp.split(",") || [] : [];
                      let temp = item.setting.dataList.map(subitem => {
                        var bool;
                        for (let i = 0, j = arr.length; i < j; i++) {
                          if ((subitem.id||subitem.value) == arr[i]) {
                            bool = true;
                            break;
                          }
                        }
                        subitem.checked = !!bool;
                        return subitem;
                      });
                      item.setting.dataList = temp;
                      item.value = arr;
                    } else if (item.type == "formula") {
                      let valueArr = obj[key]?obj[key].split(','):[];
                      item.value = valueArr[0];
                      if(valueArr.length>1){
                        let subarr = item.setting.dataList||[];
                        for(let subi=0,subj=subarr.length;subi<subj;subi++){
                          item.setting.dataList[subi].value = valueArr[subi+1];
                        }
                        if (item.setting.checkform && item.setting.checkform.compare){
                          let re = false;
                          switch (item.setting.checkform.compare){
                            case "lt":
                              re = Number(item.value) < Number(item.setting.checkform.value);
                              break;
                            case "le":
                              re = Number(item.value) <= Number(item.setting.checkform.value);
                              break;
                            case "gt":
                              re = Number(item.value) > Number(item.setting.checkform.value);
                              break;
                            case "ge":
                              re = Number(item.value) >= Number(item.setting.checkform.value);
                              break;
                            case "eq":
                              re = Number(item.value) == Number(item.setting.checkform.value);
                              break;
                          }
                          if(re){
                            item.setting.tips="";
                          }else{
                            item.setting.tips = item.setting.checkform.errorTip||'';
                          }
                        }
                      }
                    } else {
                      item.value = obj[key] || "";
                    }
                    if (item.attribute == "ispass") {
                      $that.ispass = obj[key] == "true" ? true : false;
                    }
                    break;
                  }
                }
              }
              item.imgmax = item.imgmax || 3;
              return item;
            });
            $that.formList = arr_temp;

            let edit_temp = $that.formEditList.map(item=>{
              item.value = obj[item.attribute];
              return item;
            });
            $that.formEditList = edit_temp;
          }
          $that.$indicator.close();
          setTimeout(function() {
            $that.auth.isAutoSave = true;
          }, 500);
        }
      );
    },
    // 获取当前用户权限
    getAuth: function() {
      var $that = this;
      this.$ajax.get(
        this.$$api.mobile.getProcedureAuth,
        {
          itemid: this.itemid,
          billbid: this.sid
        },
        function(res) {
          if (res.status == 200) {
            var obj = res.data.detailMsg.data;
            $that.auth.editable = obj.editable == "Y" ? true : false;
          }
        }
      );
    },
    // 上传图片
    imgFile: function(type, file, fun) {
      var $that = this;
      // this.$indicator.open();
      this.$ajax.get(this.$$api.mobile.getimgtoken, {}, function(res) {
        if (res.status == 200) {
          var token = res.data.token;
          var fileid = res.data.fileid;
          let param = new FormData(); //创建form对象
          param.append("file", file, file.name); //通过append向form对象添加数据
          param.append("chunk", "0"); //添加form表单中其他数据
          param.append("token", token); //添加form表单中其他数据
          param.append("key", fileid); //添加form表单中其他数据
          let config = {
            headers: { "Content-Type": "multipart/form-data" }
          };
          axios
            .post($that.$$api.mobile.qiniuUpload, param, config)
            .then(data => {
              var key = data.data.key;
              if (fun) fun(key);
              $that.$indicator.close();
            });
        }
      });
    },
    //上传base64图片
    putb64(picBase) {
      var $that = this;
      this.$indicator.open();
      this.$ajax.get(this.$$api.mobile.getimgtoken, {}, function(res) {
        if (res.status == 200) {
          var token = res.data.token;
          /*picBase是base64图片带头部的完整编码*/
          var picUrl; /*picUrl用来存储返回来的url*/
          /*把头部的data:image/png;base64,去掉。（注意：base64后面的逗号也去掉）*/
          picBase = picBase.substring(22);
          var url = "http://upload-z1.qiniu.com/putb64/-1";
          var xhr = new XMLHttpRequest();
          xhr.onreadystatechange = function() {
            if (xhr.readyState == 4) {
              var keyText = xhr.responseText;
              var json = eval("(" + keyText + ")"); /*把字符串转换成json*/
              /*返回的key是字符串，需要装换成json*/
              keyText = json;
              // keyText.key 是返回的图片文件名
              picUrl = "http://dmzoss.iyuhong.com.cn/" + keyText.key; //picUrl就是图片的路径
              $that.signatureImg = picUrl;
              $that.autoSave("signature", keyText.key);
              $that.$indicator.close();
            }
          };
          xhr.open("POST", url, true);
          xhr.setRequestHeader("Content-Type", "application/octet-stream");
          xhr.setRequestHeader("Authorization", "UpToken " + token);
          xhr.send(picBase);
        }
      });
    },

    /*通过base64编码字符流计算文件流大小函数*/
    fileSize(str) {
      var fileSize;
      if (str.indexOf("=") > 0) {
        var indexOf = str.indexOf("=");
        str = str.substring(0, indexOf); //把末尾的’=‘号去掉
      }
      fileSize = parseInt(str.length - (str.length / 8) * 2);
      return fileSize;
    },
    // 删除图片
    delClick: function(item, i, index) {
      var arr = this.formList;
      arr[i].value.splice(index, 1);
      this.formList = Object.assign({}, arr);
      this.autoSave(item.attribute, item.value.join(","));
    },
    autoSave(type, value,fun) {
      // if (type == "ispass") {
      //   this.ispass = value;
      // }
      if (type && this.sid && this.formid && this.auth.isAutoSave) {
        this.$ajax.get(
          this.$$api.mobile.saveProcedure,
          {
            sid: this.sid,
            formid: this.formid,
            attribute: type,
            value: value
          },
          response => {
            if (response.status >= 200 && response.status < 300) {
              if(fun)fun();
              // console.log(response);
            } else {
              // console.log(response,this.sid);
            }
          }
        );
      }
    },
    getUrl(e, item, i) {
      var $that = this;
      // var file = e.files[0];
      var file = this.$comm.toBase64(e.base64);
      this.imgFile(item.attribute, file, function(url) {
        console.log(url);
        var arr = $that.formList;
        arr[i].value.push(url);
        $that.formList = Object.assign({}, arr);
        $that.autoSave(item.attribute, item.value.join(","));
      });
      Indicator.close();
    },
    // 打分
    rateClick(item, i, index) {
      item.value = index;
      var arr = this.formList;
      arr[i].value = index;
      this.formList = Object.assign({}, arr);
      this.autoSave(item.attribute, item.value);
    },
    commit: function() {
      var $that = this;
      if (this.haspass && !this.ispass) {
        this.$messagebox.confirm("确认验收不通过？").then(action => {
          if (action == "confirm") {
            $that.commitAjax();
          }
        });
      } else {
        this.commitAjax();
      }
    },
    commitAjax: function() {
      var $that = this;
      if (!this.auth.isCommit) {
        return;
      }
      this.auth.isCommit = false;
      this.auth.editable = false;
      this.$ajax.post(
        this.$$api.mobile.commitProcedure,
        {
          sid: this.sid,
          formid: this.formid
        },
        function(res) {
          $that.$router.push("/imgupdate");
        },
        function() {
          $that.auth.isCommit = true;
          $that.auth.editable = true;
        }
      );
    },
    // 图片预览
    imgShowClick: function(e) {
      var url = e.currentTarget.dataset.src;
      if (url) {
        this.imgshow_url = url;
        this.ispart_imgshow = true;
      }
    },
    part_close: function(value) {
      this.ispart_imgshow = value;
    },

    inputChange(item, i, subIndex) {
      let val;
      let arr = this.formList;
      if (item.type == "radio") {
        let subValue = arr[i].setting.dataList[subIndex].id|| arr[i].setting.dataList[subIndex].value;
        var list_temp = arr[i].setting.dataList.map(item => {
          if ((item.value || item.id) == subValue) {
            item.checked = !item.checked;
          }else{
            item.checked = false;
          }
          if(item.checked)val = item.value;
          return item;
        });
        arr[i].value = val;
        arr[i].setting.dataList = list_temp;
      }else if(item.type == "checkbox"){
        val = [];
        let subValue = arr[i].setting.dataList[subIndex].id|| arr[i].setting.dataList[subIndex].value;
        var list_temp = arr[i].setting.dataList.map(item => {
          if ((item.value || item.id) == subValue) {
            item.checked = !item.checked;
          }
          if(item.checked)val.push(item.value);
          return item;
        });
        arr[i].value = val;
        arr[i].setting.dataList = list_temp;
      }
      this.formList = Object.assign({}, arr);
      if (item.type == "checkbox") {
        val = item.value.join(",");
      } else if (item.type == "radio") {
        val = item.value;
      }
      this.autoSave(item.attribute, val);
    },
    signatureObj(obj) {
      // this.signatureImg = obj.upImgUrl;
      console.log(obj.upImgUrl);
      this.signatureVisible = obj.signatureVal;
      this.putb64(obj.upImgUrl);
    },

    activationClick(){
      let that = this;
      let arr = this.formEditList;
      let email;
      //判断条件
      for(let i=0,j=arr.length;i<j;i++){
        if(arr[i].require=='Y'){
          if(!arr[i].value){
            this.$toast(arr[i].nullTip||'请填写必填项');
            return;
          }
          if(arr[i].attribute=='email'){
            email = arr[i].value;
          }
        }
      }
      if (!this.auth.isCommit) {
        return;
      }
      this.auth.isCommit = false;
      this.auth.editable = false;
      this.$indicator.open();
      this.autoSave('ispass', true,function(){
        that.$ajax.post(that.$$api.mobile.commitProcedure,{
            sid: that.sid,
            formid: that.formid,
            email,
          },function(res) {
            that.tipModal = true;
          },function() {
            that.auth.isCommit = true;
            that.auth.editable = true;
            that.$indicator.close()
          }
        );
      });


    },
    toLogin(){
      this.$router.push("/");
    },
  },
  watch: {}
};
</script>

<style scoped>
.star .iconfont {
  font-size: 0.8rem !important;
}
>>> .mint-switch {
  justify-content: flex-end;
}
/*  sub */
.module-body .module-body-subItem {
  min-width: 50px;
  margin: 0 5px 5px 0;
}
.module-body .module-body-subInput {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 23;
  opacity: 0;
}
.module-body .module-body-subView {
  min-width: 50px;
  margin: 0 5px 5px 0;
  /*z-index: 20;*/
  -webkit-border-radius: 50px;
  -moz-border-radius: 50px;
  border-radius: 50px;
  border: 1px solid transparent;
  padding: 10px 15px;
}
.module-body .module-body-subView.on {
  background: rgba(226, 115, 124, 0.24);
  border-color: #e50012;
  color: #e50012 !important;
}
.signaturePopup {
  width: 100vw;
  height: 101vh;
}
.signature-img-wrapper {
  width: 100%;
  height: auto;
  padding: 0px 4vw;
  box-sizing: border-box;
}
.signature-img-wrapper img {
  width: 100%;
  height: auto;
  border: 1px solid #333;
  border-radius: 4px;
}
>>>.mint-cell-wrapper {
  padding: 0 4vw;
}
.procedure .procedure-group{
  background: white;
  margin-bottom: 2vw;
}
.procedure .procedure-title{
  font-size:4vw;
  color: #000;
  background: white;
}
.activation-seat{
  height: 45vh;
}
.activation-modal{
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 200;
  width: 100%;
  height: 45vh;
  background: #fff;
  box-sizing: border-box;
  padding:3vw;
  border-top-right-radius: 15px;
  border-top-left-radius: 15px;
}
.c_btn_seat{
  width:100%;
  height: 9vh;
}
.c_btn.fix{
  position: fixed;
  bottom: 2vw;
  left: 13vw;
  width: 74vw;
}
.c_btn{
  height: 10vw;
  width: 60%;
  margin: auto;
  overflow: hidden;
  padding-top: 5px;
  padding-bottom: 5px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  border-radius: 50px;
  font-size: 4vw;
  background: red;
  color: white;
}
.c_memo{
  white-space: normal;
}
.c_shadow{
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .24);
}
  .tip-modal{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 300;
  }
  .tip-modal-bg{
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0,0,0,.6);
    width: 100%;
    height: 100%;
    z-index: 310;
  }
  .tip-modal-content{
    position: relative;
    width: 60vw;
    height: 45vw;
    background: white;
    z-index: 320;
    border-radius: 30px;
    font-size: 4.5vw;
  }
</style>



// WEBPACK FOOTER //
// src/components/procedureActivation.vue